import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import "./App.css";

import "bootstrap/dist/js/bootstrap.bundle.min";
import Herosection from "./components/herosection/Herosection";
import Wwd from "./components/Wwd/Wwd.js/Wwd";
import AboutUs from "./components/Aboutus/AboutUs";
import OurProjects from "./components/projects/OurProjects";
import Testimonials from "./components/Testimonials/Testimonials";
import Contact from "./components/Contact/Contact";
import Footer from "./components/Aboutus/Footer/Footer";
import Working from "./components/working/Working";
import Faq from "./components/faq/Faq";
import CTASection from "./components/Cta/CTASection";

const App = () => {
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowButton(window.scrollY > 300);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
      <Helmet>
        <title>Best IT Company in Nepal | Anrika Tech</title>
        <meta
          name="description"
          content="Anrika Tech is a trusted IT company in Nepal offering web development, software solutions, and digital marketing tailored to your business."
        />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://www.anrikatech.com/" />
        <meta
          property="og:title"
          content="Best IT Company in Nepal | Anrika Tech"
        />
        <meta
          property="og:description"
          content="We build websites, apps, and digital solutions in Nepal and beyond."
        />
        <meta
          property="og:image"
          content="https://www.anrikatech.com/web-app-manifest-192x192.png"
        />
        <meta property="og:url" content="https://www.anrikatech.com" />
        <meta property="og:type" content="website" />
      </Helmet>

      <div className="main-outer-div">
        <Herosection />
        <Wwd />
        <AboutUs />
        <OurProjects />
        <Working />
        <CTASection />
        <Testimonials />
        <Faq />
        <Contact />
        <Footer />

        {showButton && (
          <button className="scroll-to-top" onClick={scrollToTop}>
            ↑
          </button>
        )}
      </div>
    </>
  );
};

export default App;
